import * as betprofessor from './DesktopTransactionsTable.styles.betprofessor';
import * as betroyale from './DesktopTransactionsTable.styles.betroyale';
import * as fiestabet from './DesktopTransactionsTable.styles.fiestabet';
import * as goldenrush from './DesktopTransactionsTable.styles.goldenrush';
import * as juicybet from './DesktopTransactionsTable.styles.juicybet';
import * as puntcity from './DesktopTransactionsTable.styles.puntcity';
import * as puntgenie from './DesktopTransactionsTable.styles.puntgenie';
import * as questbet from './DesktopTransactionsTable.styles.questbet';
import * as sterlingparker from './DesktopTransactionsTable.styles.sterlingparker';
import * as vikingbet from './DesktopTransactionsTable.styles.vikingbet';
import * as volcanobet from './DesktopTransactionsTable.styles.volcanobet';
import * as forsport from './DesktopTransactionsTable.styles.forsport';
import * as junglebet from './DesktopTransactionsTable.styles.junglebet';
import * as oldgill from './DesktopTransactionsTable.styles.oldgill';
import * as sugarcastle from './DesktopTransactionsTable.styles.sugarcastle';
import * as buffalobet from './DesktopTransactionsTable.styles.buffalobet';
import * as titanbet from './DesktopTransactionsTable.styles.titanbet';
import * as slambet from './DesktopTransactionsTable.styles.slambet';
import * as gigabet from './DesktopTransactionsTable.styles.gigabet';
import * as betstride from './DesktopTransactionsTable.styles.betstride';
import * as templebet from './DesktopTransactionsTable.styles.templebet';
import * as goldenbet888 from './DesktopTransactionsTable.styles.goldenbet888';
import * as hyperbet from './DesktopTransactionsTable.styles.hyperbet';
import * as bet777 from './DesktopTransactionsTable.styles.bet777';
import * as chromabet from './DesktopTransactionsTable.styles.chromabet';
import * as bet575 from './DesktopTransactionsTable.styles.bet575';
import * as betblast from './DesktopTransactionsTable.styles.betblast';
import * as pyramidbet from './DesktopTransactionsTable.styles.pyramidbet';
import * as magnumbet from './DesktopTransactionsTable.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
